module.exports = __webpack_public_path__ + "media/images/lb/226-3afe10327c22cbb05636b9ebb3172a63.svg";